import { useAppDispatch, useAppSelector } from "@/store/hooks";
import ProductsTable from "./components/ProductsTable";
import { Plus, Trash2 } from "lucide-react";
import AddProductModal from "./components/AddProductModal";
import { Button } from "@/components/ui/button";
import {
  resetGetProduct,
  setAddProductModal,
  setFilters,
} from "./products.slice";
import ProductsSearch from "./components/ProductsSearch";
import Pagination from "@/components/Pagination/Pagination";

export default function Products() {
  // Hooks
  const dispatch = useAppDispatch();

  // Redux
  const { filters, selectedProducts, pagination } = useAppSelector(
    (state) => state.products
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <ProductsSearch />

        <div className="flex items-center gap-2">
          {selectedProducts.length > 0 && (
            <Button variant={"destructive"}>
              <Trash2 />
            </Button>
          )}
          <Button
            onClick={() => {
              dispatch(resetGetProduct());
              dispatch(setAddProductModal(true));
            }}
          >
            <Plus />
            Product
          </Button>
        </div>
      </div>
      <ProductsTable />

      {pagination.length > 0 && (
        <Pagination
          totalPages={Math.ceil(pagination.length / pagination.size)}
          currentPage={filters.page}
          onPageChange={(page) => dispatch(setFilters({ ...filters, page }))}
        />
      )}

      <AddProductModal />
    </div>
  );
}
